import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  viewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { UntilDestroy } from '@ngneat/until-destroy';

import { ButtonIconComponent } from '@blaze-shared/shared-ui';

import { BaseCellInputComponent } from '../base-cell-input.component';

import { CellDateComponent } from './date/cell-date.component';
import { CellDateTimeComponent } from './datetime/cell-date-time.component';
import { CellTimeComponent } from './time/cell-time.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-date-time',
  templateUrl: './cell-input-date-time.component.html',
  styleUrls: ['./cell-input-date-time.component.scss', '../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatIcon,
    ButtonIconComponent,
    CellDateTimeComponent,
    CellDateComponent,
    CellTimeComponent,
  ],
})
export class CellInputDateTimeComponent
  extends BaseCellInputComponent<string>
  implements OnInit, AfterViewInit
{
  cellDateComponent = viewChild<CellDateComponent>('cellDateComponent');
  cellTimeComponent = viewChild<CellTimeComponent>('cellTimeComponent');

  @Input() readonly = false;

  protected get columnType(): 'Date' | 'Time' | 'DateTime' {
    return this.column.columnType as 'Date' | 'Time' | 'DateTime';
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    switch (this.columnType) {
      case 'Date':
        this.cellDateComponent()?.openDatePicker();
        break;
      case 'Time':
        this.cellTimeComponent()?.openTimePicker();
        break;
    }
  }

  protected clearDateTimeValue(): void {
    this.formControl.patchValue(null);
    this.value = null;
    this.emitValueChanged(null);
  }
}
